import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = sessionStorage.getItem('token') || localStorage.getItem('hrms_token');
    if (!token) return true;

    if (!sessionStorage.getItem('token') && localStorage.getItem('hrms_token')) {
      sessionStorage.setItem('token', localStorage.getItem('hrms_token')!);
      const user = localStorage.getItem('hrms_user');
      if (user) sessionStorage.setItem('user', user);
    }

    try {
      const raw = sessionStorage.getItem('user') || localStorage.getItem('hrms_user');
      const user = raw ? JSON.parse(raw) : null;
      const role = ((user?.role || '').toLowerCase().replace(/^role_/, ''));
      const target = role === 'manager' ? '/dashboard/manager' : '/overview';
      return this.router.parseUrl(target);
    } catch {
      return this.router.parseUrl('/overview');
    }
  }
}
